<cc-side-bar class="archive-sidebar" [(sidebarToggled)]="sidebarToggledChange"
             (sidebarToggledChange)="SizeChanged($event)"
             [menuItemsTop]="menuItemsTop" [menuItemsBottom]="menuItemsBottom">
<!--  <span top-->
<!--        [class]="'bar-button'"-->
<!--        [pTooltip]="'recap.dialog_title'|translate"-->
<!--        (click)="showRecapListDialog()">-->
<!--    <i [class]="'bar-button-ico fa-solid fa-envelope-circle-check'"></i>-->
<!--    <div class="bar-button-text">{{'recap.dialog_title'|translate}}</div>-->
<!--  </span>-->

  <ng-content bottom select="[bottom]"></ng-content>
  <ng-content body select="[body]"></ng-content>
<!--  <app-archive-tasks-button top [origins]="[Origin.WEB_RECAP]"-->
<!--                            [buttonTitle]="'page.profile.recap.tasks'" [transPartKey]="'profile.recap.task'"></app-archive-tasks-button>-->
</cc-side-bar>

<!--<app-archive-recap-list-dialog  [(dialogFormVisible)]="recapListDialogVisible"></app-archive-recap-list-dialog>-->
